import { ReactNode, useMemo } from 'react';
import { useFormikContext } from 'formik';
import {
  ButtonBase,
  Card,
  CardMedia,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { IMAGE_PLACEHOLDER } from '@/constants/global';

interface Props {
  title: string;
  description?: string;
  icon?: ReactNode;
  img?: string;
  name?: string;
  value?: string;
  onClick?: () => void;
}

const StepCard = ({
  title,
  description,
  icon,
  img,
  name,
  value,
  onClick,
}: Props) => {
  const theme = useTheme();
  const { values } = useFormikContext();

  const isSelected = useMemo(() => {
    return value === values[name];
  }, [values]);

  return (
    <ButtonBase
      defaultValue={value ?? ''}
      id={title}
      onClick={() =>
        onClick({
          target: {
            name: name,
            value: value,
          },
        })
      }
      sx={{
        width: '100%',
      }}
    >
      <Card
        sx={{
          width: '100%',
          minWidth: { xs: '150px', md: '175px' },
          borderRadius: '8px',
          border: isSelected
            ? `2px solid ${theme.palette.primary.main}`
            : '2px solid transparent',
        }}
      >
        <Stack flex={1}>
          {icon ? (
            <Stack alignItems="center" justifyContent="center" flex={1}>
              <img src={icon} alt={title} width="100" />
            </Stack>
          ) : null}

          {img ? (
            <CardMedia
              className="card_img"
              component={'img'}
              title={title}
              image={img ?? IMAGE_PLACEHOLDER}
              sx={{ height: '150px' }}
            />
          ) : null}
          <Stack
            alignItems={'center'}
            justifyContent="center"
            flex={1}
            padding={2}
          >
            <Typography color={isSelected ? 'primary' : undefined}>
              {title}
            </Typography>
            {description ? (
              <Typography variant="caption">{description}</Typography>
            ) : null}
          </Stack>
        </Stack>
      </Card>
    </ButtonBase>
  );
};

export default StepCard;
